module.exports = __webpack_public_path__ + "static/h2h_full_logo-820f0dc0e995dbca2efc6959aa86b5a2.webp";